import React, { KeyboardEvent } from 'react';
import { Box, CloseIcon, Text } from '@razorpay/blade/components';
import {
  ChipRemoveButton,
  EnumValueChip,
  EnumValueInput,
  EnumValuesField,
} from '../../../styles';

type EnumValuesInputProps = {
  values: string[];
  inputValue: string;
  onInputChange: (value: string) => void;
  onCommit: () => void;
  onRemove: (value: string) => void;
};

export const EnumValuesInput = ({
  values,
  inputValue,
  onInputChange,
  onCommit,
  onRemove,
}: EnumValuesInputProps) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onCommit();
    }
  };

  return (
    <Box display="flex" flexDirection="column" gap="spacing.2">
      <Text weight="semibold">Allowed values*</Text>
      <EnumValuesField>
        {values.map((enumValue) => (
          <EnumValueChip key={enumValue}>
            {enumValue}
            <ChipRemoveButton
              type="button"
              aria-label={`Remove ${enumValue}`}
              onClick={() => onRemove(enumValue)}>
              <CloseIcon size="small" color="surface.icon.gray.muted" />
            </ChipRemoveButton>
          </EnumValueChip>
        ))}
        <EnumValueInput
          aria-label="Allowed values"
          placeholder="Add a value and press Enter"
          value={inputValue}
          onChange={(event) => onInputChange(event.target.value)}
          onBlur={() => onCommit()}
          onKeyDown={handleKeyDown}
        />
      </EnumValuesField>
      {values.length === 0 ? (
        <Text size="small" color="feedback.text.negative.intense">
          Add at least one value to continue.
        </Text>
      ) : null}
    </Box>
  );
};
